module.exports={
	"Form": "ContractTypeEditManifest",
	"Scope": "ContractType-Edit",
	"Descriptors":
	{
		"ContractTypeDetails.IDContractType":
		{
			"Name": "ID",
			"Hash": "ContractTypeEdit-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "ContractTypeEditIdentity",
				"Group": "ContractTypeEditIdentity"
			}
		},
		"ContractTypeDetails.GUIDContractType":
		{
			"Name": "GUID",
			"Hash": "ContractTypeEdit-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "ContractTypeEditIdentity",
				"Group": "ContractTypeEditIdentity"
			}
		},
		"ContractTypeDetails.Name":
		{
			"Name": "Name",
			"Hash": "ContractTypeEdit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "ContractTypeEditIdentity",
				"Group": "ContractTypeEditIdentity"
			}
		},
		"ContractTypeDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "ContractTypeEdit-Hash",
			"DataType": "String",
			"Description": "Stable short code used for imports and external references. Keep case-sensitive and avoid spaces.",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "ContractTypeEditIdentity",
				"Group": "ContractTypeEditIdentity"
			}
		},
		"ContractTypeDetails.Description":
		{
			"Name": "Description",
			"Hash": "ContractTypeEdit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 8,
				"Section": "ContractTypeEditIdentity",
				"Group": "ContractTypeEditIdentity"
			}
		},
		"ContractTypeDetails._DisplaySettings.AvailableStatusList":
		{
			"Name": "Available Statuses",
			"Hash": "ContractTypeEdit-AvailableStatusList",
			"DataType": "String",
			"Description": "Lifecycle statuses a contract of this type can occupy, in display order. Type a status name and press Enter to add it.",
			"PictForm":
			{
				"InputType": "Select2Multiple",
				"AllowCustomValues": true,
				"Row": "2",
				"Width": 6,
				"Section": "ContractTypeEditSettings",
				"Group": "ContractTypeEditSettings"
			}
		},
		"ContractTypeDetails._DisplaySettings.AllowedProjectTypeIDs":
		{
			"Name": "Allowed Project Types",
			"Hash": "ContractTypeEdit-AllowedProjectTypeIDs",
			"DataType": "String",
			"Description": "Project types allowed under a contract of this type. Leave blank to allow any project type. Manage the available project types from the Project Types card on the dashboard.",
			"PictForm":
			{
				"InputType": "Picker",
				"Multiple": true,
				"Entity": "ProjectType",
				"ValueField": "IDProjectType",
				"TextField": "Name",
				"Row": "3",
				"Width": 6,
				"Section": "ContractTypeEditSettings",
				"Group": "ContractTypeEditSettings"
			}
		},
		"ContractTypeDetails._DisplaySettings.DefaultDates":
		{
			"Name": "Default Contract Dates",
			"Hash": "ContractTypeEdit-DefaultDates",
			"DataType": "Array"
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ContractTypeEditIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ContractTypeEditIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Settings",
			"Hash": "ContractTypeEditSettings",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Settings",
					"Hash": "ContractTypeEditSettings",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Default Contract Dates",
			"Hash": "ContractTypeEditDefaultDates",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Default Contract Dates",
					"Hash": "ContractTypeEditDefaultDatesGrid",
					"Layout": "Tabular",
					"RecordSetSolvers": [],
					"RecordSetAddress": "ContractTypeDetails._DisplaySettings.DefaultDates",
					"RecordManifest": "ContractTypeDefaultDateRow",
					"ShowTitle": false
				}
			]
		}
	],
	"ReferenceManifests":
	{
		"ContractTypeDefaultDateRow":
		{
			"Scope": "ContractTypeDefaultDateRow",
			"Descriptors":
			{
				"Hash":
				{
					"Name": "Hash",
					"Hash": "ContractTypeDefaultDateRowHash",
					"DataType": "String",
					"Description": "Stable short code for the date milestone (e.g. NTP, SUBCMP).",
					"PictForm":
					{
						"InputType": "Text",
						"Section": "ContractTypeEditDefaultDates",
						"Group": "ContractTypeEditDefaultDatesGrid"
					},
					"IsTabular": true
				},
				"Name":
				{
					"Name": "Display Name",
					"Hash": "ContractTypeDefaultDateRowName",
					"DataType": "String",
					"Description": "Human-readable label shown to users (e.g. 'Notice to Proceed').",
					"PictForm":
					{
						"InputType": "Text",
						"Section": "ContractTypeEditDefaultDates",
						"Group": "ContractTypeEditDefaultDatesGrid"
					},
					"IsTabular": true
				}
			}
		}
	}
}
